export default {
    categories: '/api/v1/categories',
    messages: {
        byCategory: '/api/v1/messages/category/{id}'
    }
}